<template>
  <div class="face-sheet-detail-header">
    <div class="face-sheet-detail-header-left">
      <v-btn
        :to="{ name: 'faceSheetsTop' }"
        variant="text"
        prepend-icon="mdi-arrow-left"
      >
        戻る
      </v-btn>
      <div class="face-sheet-user-title"><span class="face-sheet-user-name">{{ headerPrimaryLabel }}</span><span class="face-sheet-user-subtitle">{{ headerSecondaryLabel }}</span></div>
      <v-chip
        v-if="isRequiredStatus"
        class="status-chip-required"
        size="small"
        variant="flat"
      >
        ハイリスク要対応
      </v-chip>
      <v-chip
        v-if="isWatchStatus"
        class="status-chip-watch"
        size="small"
        variant="flat"
      >
        要注意観察中
      </v-chip>
    </div>
    <div class="face-sheet-detail-header-right">
      <div
        ref="statusControl"
        class="status-control"
      >
        <v-btn
          variant="outlined"
          class="change-status-btn"
          @click="toggleStatusPanel"
        >
          ステータスを変更する
        </v-btn>
        <div
          v-if="isStatusPanelOpen"
          class="status-popover"
        >
          <div class="status-popover-section-title">
            ハイリスク要対応
          </div>
          <button
            type="button"
            class="status-popover-row"
            :class="{ 'is-active is-required': statusDraftHighRisk === '要対応' }"
            @click="selectStatusOption('highRisk', '要対応')"
          >
            <v-icon
              :icon="statusDraftHighRisk === '要対応' ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank'"
              class="status-popover-icon status-popover-icon-required"
            />
            <span class="status-popover-label">要対応</span>
          </button>
          <button
            type="button"
            class="status-popover-row"
            :class="{ 'is-active': statusDraftHighRisk === '対応不要' }"
            @click="selectStatusOption('highRisk', '対応不要')"
          >
            <v-icon
              :icon="statusDraftHighRisk === '対応不要' ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank'"
              class="status-popover-icon"
            />
            <span class="status-popover-label">対応不要</span>
          </button>

          <div class="status-popover-section-title second-title">
            要注意観察中
          </div>
          <button
            type="button"
            class="status-popover-row"
            :class="{ 'is-active is-watch': statusDraftWatch === '要注意観察中' }"
            @click="selectStatusOption('watch', '要注意観察中')"
          >
            <v-icon
              :icon="statusDraftWatch === '要注意観察中' ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank'"
              class="status-popover-icon status-popover-icon-watch"
            />
            <span class="status-popover-label">要注意観察中</span>
          </button>
          <button
            type="button"
            class="status-popover-row"
            :class="{ 'is-active': statusDraftWatch === 'なし' }"
            @click="selectStatusOption('watch', 'なし')"
          >
            <v-icon
              :icon="statusDraftWatch === 'なし' ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank'"
              class="status-popover-icon"
            />
            <span class="status-popover-label">なし</span>
          </button>

          <div class="status-popover-actions">
            <v-btn
              variant="outlined"
              class="status-popover-cancel"
              @click="closeStatusPanel"
            >
              キャンセル
            </v-btn>
            <v-btn
              variant="flat"
              class="status-popover-save"
              @click="saveStatus"
            >
              保存
            </v-btn>
          </div>
        </div>
      </div>
      <v-btn
        variant="outlined"
        class="open-karte-btn"
        :disabled="!latestKarteUrl"
        @click="$emit('open-latest-karte')"
      >
        直近の相談カルテを開く
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "FaceSheetDetailPageHeader",
  props: {
    userId: {
      type: String,
      required: true
    },
    displayName: {
      type: String,
      required: true
    },
    isWithdrawn: {
      type: Boolean,
      default: false
    },
    withdrawnAt: {
      type: String,
      default: ""
    },
    isRequiredStatus: {
      type: Boolean,
      default: false
    },
    isWatchStatus: {
      type: Boolean,
      default: false
    },
    latestKarteUrl: {
      type: String,
      default: ""
    }
  },
  emits: ["save-status", "open-latest-karte"],
  computed: {
    headerPrimaryLabel() {
      return this.isWithdrawn ? "※退会済みのユーザー" : this.displayName;
    },
    headerSecondaryLabel() {
      if (this.isWithdrawn) return `(退会日時: ${this.withdrawnAt || "-"})`;
      return `(ID:${this.userId})`;
    }
  },
  data() {
    return {
      isStatusPanelOpen: false,
      statusDraftHighRisk: "対応不要",
      statusDraftWatch: "なし"
    };
  },
  watch: {
    isRequiredStatus: {
      handler() {
        if (!this.isStatusPanelOpen) this.syncDraftWithCurrentStatus();
      },
      immediate: true
    },
    isWatchStatus() {
      if (!this.isStatusPanelOpen) this.syncDraftWithCurrentStatus();
    }
  },
  mounted() {
    document.addEventListener("click", this.handleDocumentClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  methods: {
    // ハイリスク要対応・要注意観察中は独立したフラグのため、それぞれ個別に初期値を合わせる。
    syncDraftWithCurrentStatus() {
      this.statusDraftHighRisk = this.isRequiredStatus ? "要対応" : "対応不要";
      this.statusDraftWatch = this.isWatchStatus ? "要注意観察中" : "なし";
    },
    toggleStatusPanel() {
      if (!this.isStatusPanelOpen) this.syncDraftWithCurrentStatus();
      this.isStatusPanelOpen = !this.isStatusPanelOpen;
    },
    closeStatusPanel() {
      this.isStatusPanelOpen = false;
    },
    selectStatusOption(group, value) {
      if (group === "highRisk") {
        this.statusDraftHighRisk = value;
        return;
      }

      this.statusDraftWatch = value;
    },
    saveStatus() {
      const statusFlags = this.resolveDraftStatus();
      this.$emit("save-status", statusFlags);
      this.closeStatusPanel();
    },
    // ハイリスク要対応・要注意観察中は独立したフラグとして両方とも送出する
    // （どちらも選択されていれば、同時にONで保存・表示される）。
    resolveDraftStatus() {
      return {
        actionRequired: this.statusDraftHighRisk === "要対応",
        watching: this.statusDraftWatch === "要注意観察中"
      };
    },
    handleDocumentClick(event) {
      if (!this.isStatusPanelOpen) return;

      const root = this.$refs.statusControl;
      if (root && !root.contains(event.target)) {
        this.closeStatusPanel();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.face-sheet-detail-header {
  position: sticky;
  top: 48px;
  z-index: 12;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 64px;
  padding: 12px 24px;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.face-sheet-detail-header-left,
.face-sheet-detail-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.face-sheet-detail-header-right {
  position: relative;
}

.face-sheet-user-title {
  font-size: 1rem;
  font-weight: bold;
  white-space: nowrap;
}

.face-sheet-user-name {
  font-size: 1.15rem;
}

.face-sheet-user-subtitle {
  margin-left: 2px;
}

.status-chip-required {
  background-color: #f9e8ee;
  color: #e64779;
  font-weight: 600;
}

.status-chip-watch {
  background-color: #fbeee3;
  color: #e97a1d;
  font-weight: 600;
}

.change-status-btn {
  border-color: #7f8083 !important;
  color: #7f8083 !important;
}

.open-karte-btn {
  border-color: #40c6c6 !important;
  color: #40c6c6 !important;
}

.status-control {
  position: relative;
}

.status-popover {
  background: #f7f7f7;
  border: 1px solid #d8d8d8;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  left: 0;
  min-width: 332px;
  padding: 12px;
  position: absolute;
  top: calc(100% + 8px);
  z-index: 30;
}

.status-popover-section-title {
  color: #7f8083;
  font-size: 0.9rem;
  font-weight: 700;
  margin-bottom: 4px;
}

.status-popover-section-title.second-title {
  margin-top: 10px;
}

.status-popover-row {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  min-height: 38px;
  padding: 0 8px;
  width: 100%;
}

.status-popover-row.is-active.is-required {
  background-color: #f8e7ed;
}

.status-popover-row.is-active.is-watch {
  background-color: #f6eee7;
}

.status-popover-icon {
  color: #a7a8ab;
  font-size: 1.75rem;
}

.status-popover-icon-required {
  color: #dc2e54;
}

.status-popover-icon-watch {
  color: #f58b2e;
}

.status-popover-label {
  color: #202124;
  font-size: 0.95rem;
  font-weight: 700;
}

.status-popover-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.status-popover-cancel,
.status-popover-save {
  border-radius: 8px;
  flex: 1;
  font-size: 1rem;
  font-weight: 700;
  height: 34px;
  letter-spacing: 0;
}

.status-popover-cancel {
  border-color: #7f8083 !important;
  color: #7f8083 !important;
}

.status-popover-save {
  background-color: #40c6c6 !important;
  color: #ffffff !important;
}
</style>
